<template>
    <div v-loading="loading" class=" main" style="border: 0 ">
        <div style="font-size:40px ; margin:0px 20px;">欢迎登录</div>
            <el-col>
                <el-col :span="9" class="whiteBg" style="height: 370px; margin: 20px; ">
                    <el-row style="font-size: 25px; margin: 15px 10px; font-weight: 700;" >音频数据一览</el-row>
                    <el-row style="margin-top: 60px;">
                        <el-col :span="10" class="numData">{{audioTotal}}首</el-col>
                        <el-col :span="10" class="numData">{{audioTotalPlay}}次</el-col>
                    </el-row>
                <el-row>
                    <el-col :span="10" class="textData" style="font-weight: 500;">总音频</el-col>
                    <el-col :span="10" class="textData"  style="font-weight: 500;">累计被收听</el-col>

                </el-row>

                </el-col>
                <el-col :span="13" class="whiteBg" style="height: 370px;  margin: 20px;">
                    <el-row style="font-size: 25px; margin: 11px 10px;">音乐播放量TOP10</el-row>
                    <el-row style="font-size: 15px; margin: 15px 10px;">
                        <el-col :span="11" class="textData">
                            <el-row  v-for="(item,index) in audioPlayTop10" :key="index">
                                <el-col :span="3" class="texcontent" style="height: 57px; line-height: 57px;" >{{index +1}}</el-col>
                                <el-col :span="6"  style="width: 55px;">
                                    <img style="width: 90%;" :src="item.cover">
                                </el-col>
                                <el-col :span="13" style="display: flex; flex-direction: column; align-items: flex-start; margin-left: 10px;">
                                    <el-row class="texcontent" style="width: 220px;  white-space: nowrap; overflow: hidden;  text-overflow: ellipsis;text-align: left;">{{item.audioTitle}}</el-row>
                                    <el-row class="texcontent" style="font-size: 12px; color: gray;">被播放{{item.playCount}}次</el-row>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="11" class="textData">
                            <el-row  v-for="(item,index) in audioPlayTop101" :key="index">
                                <el-col :span="3" class="texcontent" style="height: 57px; line-height: 57px;" >{{index +6}}</el-col>
                                <el-col :span="4"  style="width: 55px;">
                                    <img style="width: 90%;" :src="item.cover">
                                </el-col>
                                <el-col :span="13"  style="display: flex; flex-direction: column; align-items: flex-start; margin-left: 10px; ">
                                    <el-row class="texcontent"  style="width: 220px;  white-space: nowrap; overflow: hidden;  text-overflow: ellipsis;text-align: left;">{{item.audioTitle}}</el-row>
                                    <el-row class="texcontent"  style="font-size: 12px; color: gray;">被播放{{item.playCount}}次</el-row>
                                </el-col>
                            </el-row>

                        </el-col>

                    </el-row>
                </el-col>
            </el-col>
            <el-col>
                <el-col :span="9" class="whiteBg" style="height: 350px; margin: 20px; ">
                    <el-row style="font-size: 25px; margin: 15px 10px; font-weight: 700;">用户数据一览</el-row>
                    <el-row style="margin-top: 60px;">
                    <el-col :span="10" class="numData">{{userTotal}}人</el-col>
                    <el-col :span="10" class="numData">{{userTotalNew}}人</el-col>

                </el-row>
                <el-row>
                    <el-col :span="10" class="textData"  style="font-weight: 500;">总音频</el-col>
                    <el-col :span="10" class="textData"  style="font-weight: 500;">累计被收听</el-col>

                </el-row>
                </el-col>
                <el-col :span="6" class="whiteBg" style=" height: 350px;  margin: 20px 32px 20px 20px">
                    <el-row style="font-size: 20px; margin: 15px 10px;">累计收听最长用户TOP5</el-row>
                    <el-row style="font-size: 20px; margin: 13px 10px;">
                        <el-col :span="6" class="textTopData">排序</el-col>
                        <el-col :span="7" class="textTopData">用户名</el-col>
                        <el-col :span="7" class="textTopData">时长</el-col>
                    </el-row>
                    <el-row >
                        <el-row v-for="(item,index) in userPlayTop5" :key="index">
                        <el-col :span="6" class="textTopData">{{index + 1}}</el-col>
                        <el-col :span="7" class="textTopData">{{item.username}}</el-col>
                        <el-col :span="7" class="textTopData">{{item.playMinute}}min</el-col>
                    </el-row>

                    </el-row>
                </el-col>
                <el-col :span="6" class="whiteBg" style=" height: 350px;  margin: 20px 0px 20px 20px">
                    <el-row style="font-size: 20px; margin: 15px 10px;">累计签到最多用户TOP5</el-row>
                    <el-row style="font-size: 20px; margin: 13px 10px;">
                        <el-col :span="6" class="textTopData">排序</el-col>
                        <el-col :span="7" class="textTopData">用户名</el-col>
                        <el-col :span="7" class="textTopData">天数</el-col>
                    </el-row>
                    <el-row  v-for="(item,index) in userSignTop5" :key="index">
                        <el-col :span="6" class="textTopData">{{index+1}}</el-col>
                        <el-col :span="7" class="textTopData">{{item.username}}</el-col>
                        <el-col :span="7" class="textTopData">{{item.signDays}}天</el-col>
                    </el-row>
                </el-col>
            </el-col>

    </div>
</template>

<script>
import { indexList,userWorkSpace, editQuickNavigation, getMenuList, getTopTenArticle, getTopCourseWatchDate, getUserGrowthData, courseExamine, examineCourse, articleAudit, getCourceInfo } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';
import wbTitleVue from './components/wbTitle.vue';
import barCharts from './components/barCharts.vue';
import auditContent from '../../components/common/auditContent.vue';
import lineCharts from './components/lineCharts.vue';
import { arrToStr } from '@/utils/utils';
import { courseType } from '@/utils/commonData';

var that = null;
export default {
    name: 'workbench',
    components: {
        wbTitleVue,
        barCharts,
        lineCharts,
        auditContent
    },
    data() {
        return {

            audioTotal:'',
            audioTotalPlay:'',
            userTotal:'',
            userTotalNew:'',
            audioPlayTop10:'',
            userPlayTop5:'',
            userSignTop5:'',
            loading: false,
            courseType,
            dialogVisible: false,
            // 穿梭框数据
            generateData: [],
            chooseList: [],
            dynamicList: [],
            quickNavigationList: [],
            userInfo: {
                userGroupList: []
            },
            userRiseData: [],
            waitEventsNum: 0,
            courseList: [],
            articleList: [],
            xAxisData: [],//柱状体横坐标
            series: [
                {
                    data: [],
                    type: 'bar',
                    stack: 'a',
                    name: '教师'
                },
                {
                    data: [],
                    type: 'bar',
                    stack: 'a',
                    name: '学生'
                },
                {
                    data: [],
                    type: 'bar',
                    stack: 'a',
                    name: '家长'
                }
            ], //柱状体数据
            value: [],
            yearOptionList: [],
            //注册增长人数数据
            registerDataList: [],
            textareaVisible: false,
            infoData: '',
            currentType: 1,
            auditVisible: false,
            title: '课程审核',
            canNotBack: true,//不能反馈
            doObject: {},//当前操作的动态列表数据
            qrText: '',//二维码信息,
            resourseVisible: false,
            currentRole: 3,//当前角色  1: 管理员 2：内容制作者 3：审核人员
        };
    },
    created() {
        that = this;//测试测试
        that.currentRole = localStorage.getItem('groupType');
    },
    mounted() {
        // that.getList();
        that.getheaderIndex();
        // that.getTopTenArticle();  //获取访问量前10的文章  有用
        // that.getTopCourseWatchDate(); //获取浏览数前十名的浏览数据
        // that.getUserGrowthData();  //获取用户增长数
    },
    methods: {

        //首页7个数据
        getheaderIndex() {
            var that=this
            this.loading = true
            var info = {

            };
            var data = info;
            indexList(data).then((res) => {
                
                if (res.result == 1) {
                    if(res.data != null){
                        var ress = res.data;
                        console.log('首页7个数据',ress);
                        that.audioTotal = ress.audioTotal
                        that.audioTotalPlay = ress.audioTotalPlay
                        that.userTotal = ress.userTotal
                        that.userTotalNew = ress.userTotalNew
                        that.audioPlayTop10 = ress.audioPlayTop10.slice(0,5)
                        that.audioPlayTop101 = ress.audioPlayTop10.slice(5,10)
                        that.userPlayTop5 = ress.userPlayTop5
                        that.userSignTop5 = ress.userSignTop5
                        this.loading= false
                    }else{
                        that.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        });
                    }
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        resourseSH() {
            let info = {
                id: that.doObject.waitReviewId
            };
            console.log(info);
            getCourceInfo(encrypt(JSON.stringify(info))).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    console.log('推广位列表', ress);
                    const a = document.createElement('a');
                    a.href = ress.fileUrl;
                    a.download = ress.fileName; // 下载后文件名
                    a.style.display = 'none';
                    document.body.appendChild(a);
                    a.click(); // 点击下载
                    document.body.removeChild(a); // 下载完成移除元素
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        //格式化用户组
        formateGroup(arr) {
            let res = '';
            if (arr.length == 0) {
                return res;
            }
            arr.forEach((item, index) => {
                res += item + '/';
            });
            res = res.substring(0, res.length - 1);
            return res;
        },
        //切换课程类型
        handleCommand(command) {
            that.currentType = command;
            that.getTopCourseWatchDate();
        },
        // 动态查看详情
        showInfoData(obj) {
            console.log('obj', obj);
            that.doObject = obj;
            if (obj.reviewStatus == 2 && (parseInt(obj.messageType) == 1 || parseInt(obj.messageType) == 195 || parseInt(obj.messageType) == 196 || parseInt(obj.messageType) == 197)) { //审核失败
                that.infoData = obj.feedback;
                that.textareaVisible = true;
                return;
            }
            let qrText = {};
            switch (parseInt(obj.messageType)) {
                case 1://视频制作完成
                    that.$router.push({
                        path: '/resourceLibraryManagement'
                    });
                    break;
                case 195://文章/专题
                    that.title = '文章详情';
                    qrText = {
                        jumpType: '3',
                        commonId: obj.waitReviewId,
                        jumpStr: '',
                    }
                    console.log('文章/专题', qrText);
                    that.qrText = JSON.stringify(qrText);
                    that.auditVisible = true;
                    break;
                case 196://课程审核
                    that.title = '音视频课程审核';
                    let jumpStr = {
                        from: "preview"
                    }
                    qrText = {
                        jumpType: '5',
                        commonId: obj.waitReviewId,
                        jumpStr,
                    }
                    console.log('课程审核', qrText);
                    that.qrText = JSON.stringify(qrText);
                    that.auditVisible = true;
                    break;
                case 197://资源
                    that.title = '资源审核';
                    that.resourseVisible = true;
                    break;
                case 204://学校/组织认证信息/学校未认证
                    that.$router.push({
                        path: '/schoolCertInfo'
                    });
                    break;
                case 205://教师认证信息
                    break;
                default:
                    break;
            }
        },
        auditFail() {
            that.canNotBack = false;
            that.textareaVisible = true;
            return;
        },
        //音视频/文章/资源审核
        previewPass(msg) {
            let info = {};
            switch (parseInt(that.doObject.messageType)) {
                case 195://文章/专题
                    info = {
                        id: that.doObject.waitReviewId,
                        userId: that.doObject.userId,
                        auditStatus: msg == 'reject' ? 3 : 2
                    };
                    console.log(info);
                    articleAudit(encrypt(JSON.stringify(info))).then((res) => {
                        if (res.result == 1) {
                            that.getList();
                            if (msg == "reject") {//显示反馈弹窗
                                that.canNotBack = false;
                                that.textareaVisible = true;
                                return;
                            }
                            this.$message({
                                showClose: true,
                                message: '操作成功',
                                type: 'success'
                            });
                        } else {
                            that.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    });
                    break;
                case 196://课程审核
                    info = {
                        id: that.doObject.waitReviewId,
                        userId: that.doObject.userId,
                        examineStatus: msg == 'reject' ? 3 : 2
                    };
                    console.log(info);
                    courseExamine(encrypt(JSON.stringify(info))).then((res) => {
                        if (res.result == 1) {
                            that.getList();
                            if (msg == "reject") {//显示反馈弹窗
                                that.canNotBack = false;
                                that.textareaVisible = true;
                                return;
                            }
                            this.$message({
                                showClose: true,
                                message: '操作成功',
                                type: 'success'
                            });
                        } else {
                            that.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    });
                    break;
                case 197://资源
                    info = {
                        id: that.doObject.waitReviewId,
                        userId: that.doObject.userId,
                        examineStatus: msg == 'reject' ? 3 : 2
                    };
                    console.log(info);
                    examineCourse(encrypt(JSON.stringify(info))).then((res) => {
                        if (res.result == 1) {
                            that.getList();
                            if (msg == "reject") {//显示反馈弹窗
                                that.canNotBack = false;
                                that.textareaVisible = true;
                                return;
                            }
                            that.resourseVisible = false;
                            this.$message({
                                showClose: true,
                                message: '操作成功',
                                type: 'success'
                            });
                        } else {
                            that.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    });
                    break;
                case 204://学校/组织认证信息/学校未认证
                    break;
                case 205://教师认证信息
                    break;
                default:
                    break;
            }
            that.auditVisible = false;
        },
        // 审核后调用
        afterAudit() {
            that.getList();
            that.textareaVisible = false;
            that.$message({
                showClose: true,
                message: '提交成功',
                type: 'success'
            });
        },
        //审核失败反馈信息
        previewPassFail() {
            console.log('that.doObject', that.doObject);
            let info = {};
            switch (parseInt(that.doObject.messageType)) {
                case 195://文章/专题
                    info = {
                        id: that.doObject.waitReviewId,
                        userId: that.doObject.userId,
                        auditStatus: 3,
                        feedback: that.infoData
                    };
                    console.log(info);
                    articleAudit(encrypt(JSON.stringify(info))).then((res) => {
                        if (res.result == 1) {
                            that.afterAudit();
                        } else {
                            that.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    });
                    break;
                case 196://课程审核
                    info = {
                        id: that.doObject.waitReviewId,
                        userId: that.doObject.userId,
                        examineStatus: 3,
                        feedback: that.infoData
                    };
                    console.log(info);
                    courseExamine(encrypt(JSON.stringify(info))).then((res) => {
                        if (res.result == 1) {
                            that.afterAudit();
                        } else {
                            that.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    });
                    break;
                case 197://资源
                    info = {
                        id: that.doObject.waitReviewId,
                        userId: that.doObject.userId,
                        examineStatus: 3,
                        feedback: that.infoData
                    };
                    console.log(info);
                    examineCourse(encrypt(JSON.stringify(info))).then((res) => {
                        if (res.result == 1) {
                            that.resourseVisible = false;
                            that.afterAudit();
                        } else {
                            that.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    });
                    break;
                default:
                    break;
            }
        },
        //切换季度
        handleChange(value) {
            let initStr = value[0] + value[1];
            that.registerDataList.forEach((item, index) => {
                console.log(item.date, index);
                if (item.date == initStr) {
                    that.xAxisData = that.registerDataList[index].arr.dateList;
                    that.series[0].data = that.registerDataList[index].arr.studentList;
                    that.series[1].data = that.registerDataList[index].arr.teacherList;
                    that.series[2].data = that.registerDataList[index].arr.parentList;
                }
            })
            console.log(value);
        },
        //新增快捷导航
        showDialogVisible() {
            that.dialogVisible = true;
            that.getMenuList();
        },
        //快捷导航跳转
        goPage(url) {
            that.$router.push({
                path: url
            });
        },
        // 对话框保存按钮
        saveItem() {
            let menuIds = arrToStr(that.chooseList);
            console.log('已保存', menuIds);
            let obj = {
                userId: localStorage.getItem('userId'),
                menuIds
            }
            let data = encrypt(JSON.stringify(obj));
            editQuickNavigation(data).then((res) => {
                if (res.result == 1) {
                    that.dialogVisible = false;
                    that.getList();
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        // 对话框取消按钮
        cancalItem() {
            that.dialogVisible = false;
        },
        //跳转代办列表
        toPendingList() {
            this.$router.push({
                path: '/pendingList'
            });
        },
        //快捷导航
        editQuickNavigation() {
        },
        //首页数据
        getList() {
            let obj = {
                userId: localStorage.getItem('userId')
            }
            console.log("getList", obj);
            let data = encrypt(JSON.stringify(obj));
            userWorkSpace(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data.replace(/[\r\n]/g, '')));
                    console.log("首页数据", ress);
                    that.dynamicList = ress.dynamicList;
                    that.quickNavigationList = ress.quickNavigationList;
                    that.userInfo = ress.userInfo;
                    that.userRiseData = ress.userRiseData;
                    // that.userRiseData.forEach(element => {
                    //     that.xAxisData.push(element.date);
                    //     that.series[0].data.push(element.arrData.parentList[0] ? element.arrData.parentList[0].count : 0);
                    //     that.series[1].data.push(element.arrData.studentList[0] ? element.arrData.studentList[0].count : 0);
                    //     that.series[2].data.push(element.arrData.teacherList[0] ? element.arrData.teacherList[0].count : 0);
                    // });
                    that.waitEventsNum = ress.waitEventsNum;
                    that.loading = false;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        //获取菜单列表
        getMenuList() {
            let obj = {
                userId: localStorage.getItem('userId')
            }
            let data = encrypt(JSON.stringify(obj));
            getMenuList(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data.replace(/[\r\n]/g, '')));
                    console.log("菜单数据", ress);
                    that.generateData = ress.canAddQuickNavigationList.map(item => {
                        return {
                            key: item.menuId,
                            label: item.menuName,
                            url: item.menuPath,
                            disabled: false
                        }
                    });
                    ress.userQuickNavigationList.forEach(item => {
                        that.chooseList.push(item.menuId)
                    })
                    console.log("右侧数据", that.chooseList);
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        //获取用户增长数
        getUserGrowthData() {
            getUserGrowthData().then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data.replace(/[\r\n]/g, '')));
                    console.log("获取用户增长数", ress);
                    that.yearOptionList = ress.yearOptionList;
                    that.registerDataList = ress.registerDataList;

                    //初始化柱状图
                    let yearStr = that.registerDataList[that.registerDataList.length - 1].date.substring(0, 4);
                    let quarterStr = that.registerDataList[that.registerDataList.length - 1].date.slice(-4);
                    that.value = [yearStr, quarterStr];
                    console.log('that.value', that.value);
                    that.xAxisData = that.registerDataList[that.registerDataList.length - 1].arr.dateList;
                    that.series[0].data = that.registerDataList[that.registerDataList.length - 1].arr.studentList;
                    that.series[1].data = that.registerDataList[that.registerDataList.length - 1].arr.teacherList;
                    that.series[2].data = that.registerDataList[that.registerDataList.length - 1].arr.parentList;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        //获取访问量前10的文章
        getTopTenArticle() {
            let obj = {
                userId: localStorage.getItem('userId')
            }
            let data = encrypt(JSON.stringify(obj));
            getTopTenArticle(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data.replace(/[\r\n]/g, '')));
                    console.log("获取访问量前10的文章", ress);
                    that.articleList = ress;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        //获取浏览数前十名的浏览数据
        getTopCourseWatchDate() {
            let obj = {
                courseType: that.currentType
            }
            let data = encrypt(JSON.stringify(obj));
            getTopCourseWatchDate(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data.replace(/[\r\n]/g, '')));
                    console.log("获取浏览数前十名的浏览数据", ress);
                    that.courseList = ress;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
    }
};
</script>

<style lang='scss' scoped>
/deep/.el-dialog__header .el-dialog__title {
    display: block;
}

/deep/.el-textarea.is-disabled .el-textarea__inner {
    background-color: transparent;
}

.main {
    padding: 1%;
    height: 900px;

    .main-left {
        flex-grow: 1;

        .ml-top {
            .mltl-l {
                flex-grow: 1;
                // width: 55%;
                height: 200px;
                padding: 0 20px 0 10px;

                .mltll-left {
                    .mltlll-img {
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        overflow: hidden;
                        flex-shrink: 0;
                    }

                    .mltlll-txt {
                        margin-left: 10px;

                        .mltlllt-s {
                            margin-top: 10px;
                        }
                    }
                }

                // .mltll-right {
                //     cursor: pointer;
                // }
            }

            .mltl-r {
                width: 330px;
                height: 200px;
                margin-left: 10px;
                flex-shrink: 0;

                .mltlr-drop {
                    position: absolute;
                    right: 10px;
                    top: 10px;
                    z-index: 10;
                    width: 140px;
                }
            }
        }

        .ml-bottom {
            width: 100%;
            height: 430px;
            margin-top: 10px;

            .mlb-list {
                height: calc(100% - 39px);
                padding-left: 20px;
                padding-right: 50px;
                overflow-x: hidden;
                overflow-y: scroll;

                .mlbl-item {
                    height: 70px;
                    padding-right: 20px;
                    border-bottom: 1px solid #D8D8D8;

                    &:last-child {
                        border: none;
                    }

                    .mlbli-r {
                        flex-shrink: 0;
                        cursor: pointer;
                    }
                }
            }
        }
    }

    .main-right {
        width: 40%;
        margin-left: 1%;

        .mr-quick {
            width: 100%;
            height: 200px;

            .mrq-ul {
                padding: 20px;
                flex-wrap: wrap;
                white-space: nowrap;

                .mrq-li {
                    margin-right: 30px;
                    margin-bottom: 20px;
                    cursor: pointer;
                }
            }
        }

        .mr-hot {
            width: 100%;
            height: 200px;
            margin-top: 10px;

            .el-carousel__item--card {
                border-radius: 2px;
                overflow: hidden;
                background-color: #ECF5FF;
            }

            .el-carousel__item--card.is-active {
                background-color: #C6E2FF;
            }

            .mrhi-name {
                height: 32px;
                line-height: 32px;
                padding: 0 16px;
            }

            .mrhi-con {
                height: 100px;
                padding: 10px;

                .mrhic-day {
                    margin-top: 4px;
                }
            }

        }

        .mr-enter {
            width: 100%;
            height: 210px;
            margin-top: 10px;

            .mre-items {
                height: calc(100% - 39px);
                padding: 11px 10px;
                overflow-y: hidden;
                overflow-x: scroll;
                white-space: nowrap;

                .mrei-one {
                    width: 30%;
                    flex-shrink: 0;

                    .mreio-name {
                        line-height: 22px;
                        text-align: center;
                    }

                    .mreio-total {
                        margin-top: 5px;
                    }

                    .mreio-sta {
                        margin-top: 4px;
                    }

                    .mreio-db {
                        margin: 4px auto 0;
                        margin-left: 4px;
                    }
                }
            }

        }

        .mrh-course {
            position: absolute;
            right: 2px;
            top: 2px;
        }
    }
}

.numData{
    margin: 18px 0; 
    font-size: 27px; 
    font-weight: 600;
    text-align: center;

    
}
.textData{
    margin: 18px 0; 
    font-size: 23px; 
    font-weight: 700;
    text-align: center;
}
.textTopData{
    margin: 12px 0; 
    font-size: 15px; 
    text-align: center;
}
.texcontent{
    font-size: 13px;
    font-weight: 500;
}
</style>
text